<template>
  <div v-if="user && user.plan === 'demo'" class="alert-container">
    <div class="demo-user-alert">
      <div
        v-if="user.expires - new Date().getTime() > 0"
        ref="notExpired"
        class="alert-text"
        :class="{ more: more }"
      >
        Your demo ends in {{ expires }}.
        <a
          href="https://360mediahouse.com/start-using-vr-today/"
          target="_blank"
          >Contact 360Mediahouse</a
        >
        to upgrade your licence. After your demo expires, you wont be able to
        use your account.
      </div>
      <div v-else ref="expired" class="alert-text" :class="{ more: more }">
        Your demo has expired.
        <a
          href="https://360mediahouse.com/start-using-vr-today/"
          target="_blank"
          >Contact 360Mediahouse</a
        >
        to upgrade your licence.
      </div>
      <button v-if="!more && overflow" class="toggle-link" @click="more = true">
        More
      </button>
      <button
        v-else-if="more && !overflow"
        class="toggle-link"
        @click="more = false"
      >
        Less
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'DemoUserAlert',
  data() {
    return {
      more: false,
      overflow: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
    expires() {
      if (this.user.expires == 0) {
        return 0;
      }
      const days = Math.floor(
        (this.user.expires - new Date().getTime()) / 1000 / 60 / 60 / 24,
      );
      if (days < 1) {
        const hours = Math.floor(
          (this.user.expires - new Date().getTime()) / 1000 / 60 / 60,
        );
        return `${hours} hours`;
      }
      return `${days} days`;
    },
  },
  mounted() {
    this.isOverflowing();

    window.addEventListener('resize', () => {
      this.isOverflowing();
    });
  },
  updated() {
    this.isOverflowing();
  },
  methods: {
    isOverflowing() {
      const expired = this.$refs.expired;
      const notExpired = this.$refs.notExpired;
      if (expired) {
        this.overflow =
          expired.offsetHeight < expired.scrollHeight ||
          expired.offsetWidth < expired.scrollWidth;
      } else if (notExpired) {
        this.overflow =
          notExpired.offsetHeight < notExpired.scrollHeight ||
          notExpired.offsetWidth < notExpired.scrollWidth;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-container {
  z-index: 1;
  margin: $space-3 auto 0;
  @include flexCenter(row);
  .demo-user-alert {
    @include flexCenter(row);
    background: color(warning-bg);
    border: 1px solid rgba(217, 119, 6, 0.35);
    border-radius: $radius-lg;
    box-shadow: $shadow-sm;
    color: color(warning);

    width: 70vw;
    padding: $space-3 $space-5;
    font-size: $text-sm;
    font-weight: $weight-semibold;
    text-align: center;
    .alert-text {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1; /* number of lines to show */
      -webkit-box-orient: vertical;
      a {
        color: color(warning);
        text-decoration: underline;
      }
    }
    .alert-text.more {
      -webkit-line-clamp: unset;
    }
  }
  .toggle-link {
    @include btn-modern(secondary);
    padding: $space-1 $space-3;
    margin-left: $space-3;
    font-size: $text-xs;
    text-transform: uppercase;
  }
}
</style>
